import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'

import 'vuetify/dist/vuetify.min.css'
import '@fortawesome/fontawesome-free/css/all.css'
import GlobalEvents from 'vue-global-events'
import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import JsonCSV from 'vue-json-csv'
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

Vue.config.devtools = true
Vue.config.productionTip = false

// register globally
// see docs for available options
const datepickerOptions = {
  sundayFirst: false,
  dateLabelFormat: 'dddd, MMMM D, YYYY',
  days: ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'],
  daysShort: ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'],
  monthNames: [
    'Gennaio',
    'Febbraio',
    'Marzo',
    'Aprile',
    'Maggio',
    'Giugno',
    'Luglio',
    'Agosto',
    'Settembre',
    'Ottobre',
    'Novembre',
    'Dicembre'
  ],
  colors: {
    selected: '#FF6E00',
    inRange: '#ffbe06',
    selectedText: '#fff',
    text: '#565a5c',
    inRangeBorder: '#ff2b10',
    disabled: '#fff',
    hoveredInRange: '#ffba0c'
  },
  texts: {
    apply: 'Applica',
    cancel: 'Cancella',
    keyboardShortcuts: 'Keyboard Shortcuts'
  },
  keyboardShortcuts: [
    {symbol: '↵', label: 'Seleziona la data in focus', symbolDescription: 'Invio'},
    {symbol: '←/→', label: 'Destra e sinistra per muoversi sui giorni.', symbolDescription: 'Frecce Sinistra/Destra'},
    {symbol: '↑/↓', label: 'Su e giu per muoversi sulle settimane.', symbolDescription: 'Frecce Su/Giu' },
    {symbol: 'PgUp/PgDn', label: 'Cambia i mesi.', symbolDescription: 'PageUp and PageDown '},
    {symbol: 'Home/End', label: 'Vai al primo o l\'ultimo giorno della settimana', symbolDescription: 'Home or End'},
    {symbol: 'Esc', label: 'Chiudi questo pannello', symbolDescription: 'Esc'},
    {symbol: '?', label: 'Apri questo pannello ', symbolDescription: '?'}

  ]
}

// make sure we can use it in our components
Vue.use(AirbnbStyleDatepicker, datepickerOptions)
Vue.component('GlobalEvents', GlobalEvents)
Vue.component('downloadCsv', JsonCSV)

Vue.use(VuejsDialog)
Vue.use(Vuetify, {
  iconfont: 'fa',
  theme: {
    primary: '#FF9800', // orange
    secondary: '#FF6E00', // orange lighten-3
    accent: 'black',
    error: '#ff5252',
    info: '#EFEFEF',
    success: '#2C7F48',
    warning: 'yellow'
  }
})

Vue.config.productionTip = false

Vue.filter('formatDate', function (value) {
  if (value) {
    let day = value.split(' ')[0].split('-')[0]
    let month = value.split(' ')[0].split('-')[1]
    let year = value.split(' ')[0].split('-')[2]
    let data = day + '/' + month + '/' + year
    return data
  }
})

Vue.filter('highlight', function (word, query) {
  var check = new RegExp(query, 'ig')
  return word.toString().replace(check, function (matchedText, a, b) {
    return ('<strong style="text-decoration:underline">' + matchedText + '</strong>')
  })
})

/* eslint-disable no-new */

/* conviene gestire l'aoutlogin prima della creazione dell'istanza di VUE facendo così
  * lo stato rimane persistente
   * **/

store.dispatch('tryAutoLogin').then(() => {
  new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
  })
})

// grab error lato client
Vue.config.errorHandler = function (err, vm, info) {
  console.log(err)
}

Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf())
  date.setDate(date.getDate() + days)
  return date
}



// WEBPACK FOOTER //
// ./src/main.js